export default __webpack_public_path__ + "static/media/zapier.1e64d44e.svg";